import React, { useState } from 'react';
import api from '../api';
import { useNavigate } from 'react-router-dom';

const Login = ({ setToken }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const navigate = useNavigate();

    const handleLogin = () => {
        // Assign a login-specific callback for reCAPTCHA token.
        window.onCaptchaSuccess = function (token) {
            console.log('✔️ reCAPTCHA token received:', token);
            api
                .post('/users/login', { email, password, captchaToken: token })
                .then(res => {
                    localStorage.setItem('uma_token', res.data.token);
                    setToken(res.data.token);
                    navigate('/');
                })
                .catch(error => {
                    const msg = error?.response?.data?.error || 'Unknown login error.';
                    setErrorMsg(msg);
                    if (msg.includes('UMA access expired')) {
                        alert('Access expired. You may be eligible for a temporary restore.');
                    }
                });
        };
        // Trigger the invisible reCAPTCHA.
        window.grecaptcha.execute();
    };

    return (
        <div className="terminal min-h-screen flex items-center justify-center font-mono text-green-300">
            <div className="w-full max-w-md p-6 border border-green-500 bg-black rounded-md shadow-lg">
                <h2 className="text-xl text-green-400 mb-4 text-center">Login to UMA</h2>

                <input
                    placeholder="Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className="input-terminal mb-3"
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    className="input-terminal mb-6"
                />

                <button onClick={handleLogin} className="btn-primary w-full mb-2">
                    Uplink to access UMA on IKOBU 07-A5
                </button>

                {errorMsg && <p className="mt-4 text-red-400 text-sm">{errorMsg}</p>}
            </div>
        </div>
    );
};

export default Login;